import { render, staticRenderFns } from "./add-deduction.vue?vue&type=template&id=0e7ff45c&"
import script from "./add-deduction.vue?vue&type=script&lang=js&"
export * from "./add-deduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports